import { useState } from "react";

import BlockIcon from "@mui/icons-material/Block";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";

import { BlockCarrierModal } from "components/Shipper/components/BlockCarrierButton";
import { CarrierBlockedSource } from "constants/index";
import { useDisclosure } from "hooks";

import type { CarrierMemberStats } from "types/company/carrier";

interface Props {
  member: CarrierMemberStats;
  companyName: string;
  onBlocked: VoidFunction;
}

/** The menu at the end of a Team row, shipper view only. */
export function CarrierTeamRowMenu(props: Props) {
  const { member, companyName, onBlocked } = props;
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const blockModal = useDisclosure();

  return (
    <>
      <Tooltip title="More actions for this person">
        <IconButton size="small" onClick={(e) => setAnchor(e.currentTarget)}>
          <MoreVertIcon />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchor}
        open={anchor != null}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem
          onClick={() => {
            setAnchor(null);
            blockModal.onOpen();
          }}
        >
          <ListItemIcon>
            <BlockIcon fontSize="small" color="error" />
          </ListItemIcon>
          <ListItemText
            primary="Block carrier"
            primaryTypographyProps={{ color: "error" }}
          />
        </MenuItem>
      </Menu>
      {blockModal.isOpen && (
        <BlockCarrierModal
          open={blockModal.isOpen}
          onClose={blockModal.onClose}
          carrierId={member.role_id}
          firstName={member.first_name}
          lastName={member.last_name}
          companyName={companyName}
          source={CarrierBlockedSource.CARRIER_PROFILE_TEAM}
          onCarrierBlocked={onBlocked}
        />
      )}
    </>
  );
}
